import { useState, useEffect, useCallback } from 'react';
import { Theme } from '../types';

const lightTheme: Theme = {
  name: 'light',
  colors: {
    bg: '#f6f8ff',
    card: '#ffffff',
    text: '#0c1b3a',
    muted: '#4a5b86',
    border: '#d9e0f3',
    accent: '#2c6cf6',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
  },
};

const darkTheme: Theme = {
  name: 'dark',
  colors: {
    bg: '#0b1220',
    card: '#111a33',
    text: '#eaf0ff',
    muted: '#9fb0d7',
    border: '#1f2a4b',
    accent: '#6aa6ff',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
  },
};

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = localStorage.getItem('ectd-theme');
    if (saved === 'dark') return darkTheme;
    return lightTheme;
  });

  useEffect(() => {
    // Apply theme to document
    document.documentElement.setAttribute('data-theme', theme.name);
    
    // Update CSS custom properties
    const root = document.documentElement;
    Object.entries(theme.colors).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
    
    // Save to localStorage
    localStorage.setItem('ectd-theme', theme.name);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => prev.name === 'light' ? darkTheme : lightTheme);
  }, []);

  const setLightTheme = useCallback(() => {
    setTheme(lightTheme);
  }, []);

  const setDarkTheme = useCallback(() => {
    setTheme(darkTheme);
  }, []);

  return {
    theme,
    toggleTheme,
    setLightTheme,
    setDarkTheme,
  };
}

